import { Brand } from '../components/atelier';
import { CONTACT_EMAIL } from '../lib/links';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <Brand />
        <span className="footer-copy">© 2026</span>
        <div style={{ display: 'flex', gap: 28 }}>
          <a href="#how">How</a>
          <a href="#workflow">Fit</a>
          <a href="#pricing">Pricing</a>
          <a href="#faq">FAQ</a>
          <a href={`mailto:${CONTACT_EMAIL}`}>Email</a>
        </div>
      </div>
    </footer>
  );
}
